import React, {FC} from 'react';
// Import Styles
import styled from 'styled-components';
// Import Models and other configuration
import { SingleEvent } from '../../../models/eventItem';



import SocialShare from '../../../components/Common/SocialShare';

interface IShareEvent {
  event: SingleEvent;
  openShare: boolean;
}

const ShareEvent: FC<IShareEvent> = ({event, openShare}) => {
  

  return (
    <ShareButtonsWrapper className={openShare ? 'showShare' : ''}>
       <SocialShare 
          title={event.title}
          description={event.description}
      />  
  </ShareButtonsWrapper>
  )
}

const ShareButtonsWrapper = styled.div`
  margin-bottom: 30px;
  display: flex;
  position: absolute;
  top: 100%;
  left: 20px;
  z-index: 1;
  margin-top: 0;
  opacity: 0;
  pointer-events: none;
  transition: all 100ms ease-in-out;

  @media (max-width: 576px) {
    left: 50%;
    transform: translateX(50%);
  }

  @media (max-width: 576px) {
    left: 0;
    right: 0;
    transform: translateX(0);
  }

  button {
    opacity: 0;
    pointer-events: none;
    transition: all 600ms ease-in-out;
  }

  &.showShare {
    opacity: 1;
    pointer-events: auto;
    margin-top: 10px;

    @media (max-width: 576px) {
      margin-top: 0;
    }

    button {
      opacity: 1;
      pointer-events: auto;

      &:nth-child(1) {
        transition-delay: 100ms;
      }

      &:nth-child(2) {
        transition-delay: 150ms;
      }

      &:nth-child(3) {
        transition-delay: 200ms;
      }

      &:nth-child(4) {
        transition-delay: 250ms;
      }

      &:nth-child(5) {
        transition-delay: 300ms;
      }

      &:nth-child(6) {
        transition-delay: 350ms;
      }

      &:nth-child(7) {
        transition-delay: 400ms;
      }

      &:nth-child(8) {
        transition-delay: 300ms;
      }

      &:nth-child(9) {
        transition-delay: 400ms;
      }

      &:nth-child(10) {
        transition-delay: 400ms;
      }
    }
  }
`;

export default ShareEvent;
